import React from 'react';

// v3.5.99.7.24 — optional agreement effective date.
//
// When set, the Service Order's "Effective" line reads this date (e.g.
// "June 1, 2026") instead of the default "Upon Client signature" — used to
// back-date an agreement for special circumstances. Stored on
// quotes.inputs.effectiveDate as a plain YYYY-MM-DD string; the Service Order
// renderer (buildSignatureDocument.renderSOHeader) formats it timezone-safe.
//
// The document "Date" row is unaffected — it stays the true prepared date.
// Editable by any rep on the quote; every change is captured in version
// history (quoteDiff tracks inputs.effectiveDate).

export default function AgreementEffectiveDate({ value, onChange }) {
  return (
    <div style={{ marginTop: 8 }}>
      <label style={{ display: 'block', fontSize: 11, fontWeight: 700, color: '#0f1e3c', marginBottom: 3 }}>
        Agreement Effective Date <span style={{ fontWeight: 400, color: '#6b7280' }}>(optional — back-date)</span>
      </label>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <input
          type="date"
          value={value || ''}
          onChange={(e) => onChange(e.target.value || '')}
          style={{ fontSize: 12, padding: '5px 7px', border: '1px solid #d1d5db', borderRadius: 4, color: '#0f1e3c', background: '#fff' }}
        />
        {value && (
          <button
            type="button"
            onClick={() => onChange('')}
            style={{ fontSize: 10, padding: '3px 8px', background: '#fff', color: '#6b7280', border: '1px solid #e5e7eb', borderRadius: 4, cursor: 'pointer' }}
          >
            Clear
          </button>
        )}
      </div>
      <div style={{ fontSize: 10, color: '#6b7280', marginTop: 3 }}>
        {value
          ? 'The signed Service Order will read “Effective: ' + formatPreview(value) + '”.'
          : 'Leave blank for the standard “Effective: Upon Client signature”.'}
      </div>
    </div>
  );
}

// Timezone-safe preview (mirrors the server-side formatAgreementDate).
function formatPreview(iso) {
  const m = String(iso || '').match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return iso;
  return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]))
    .toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
}
